import React from 'react';
import { TodoTree } from '../../types/todo';
import { TODAY } from '../../utils/constants';

interface OrderStepProps {
  tree: TodoTree;
  selected: string[];
  onMove: (from: number, to: number) => void;
}

/**
 * Final wizard step: rank the day. Position is the whole triage model — there
 * are no A/B/C labels to reconcile with the tree's own priority field.
 */
const OrderStep: React.FC<OrderStepProps> = ({ tree, selected, onMove }) => (
  <div className="daily-review-step">
    <h4 className="daily-review-step-title">{TODAY.ORDER_STEP_TITLE}</h4>
    <p className="daily-review-hint">{TODAY.ORDER_STEP_HINT}</p>

    {selected.length > TODAY.SOFT_ITEM_LIMIT && (
      <p className="daily-review-warning" role="status">{TODAY.OVER_LIMIT_HINT}</p>
    )}

    {selected.length === 0 ? (
      <p className="daily-review-empty">{TODAY.ORDER_EMPTY}</p>
    ) : (
      <ol className="daily-review-order">
        {selected.map((id, index) => (
          <li key={id} className="daily-review-order-row">
            <span className="daily-review-order-rank">{index + 1}</span>
            <span className="daily-review-order-name" data-testid="order-row-name">{tree[id]?.name}</span>
            <span className="daily-review-order-actions">
              <button
                onClick={() => onMove(index, index - 1)}
                disabled={index === 0}
                title={TODAY.MOVE_UP_TOOLTIP}
                aria-label={`${TODAY.MOVE_UP_TOOLTIP}: ${tree[id]?.name}`}
              >
                ↑
              </button>
              <button
                onClick={() => onMove(index, index + 1)}
                disabled={index === selected.length - 1}
                title={TODAY.MOVE_DOWN_TOOLTIP}
                aria-label={`${TODAY.MOVE_DOWN_TOOLTIP}: ${tree[id]?.name}`}
              >
                ↓
              </button>
            </span>
          </li>
        ))}
      </ol>
    )}
  </div>
);

export default OrderStep;
